import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { Body2, Caption, colors, fontWeights, spacing } from 'ui/theme';

export const Card = styled.div`
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
  padding: ${spacing.base};
  height: auto;
  background-color: ${colors.white};
  box-shadow: 0 1px ${spacing.single} 0 rgb(0 0 0 / 0.06);
`;

export const constructFlexSpacing = (spacingValue: string) => `
  display: flex;
  column-gap: ${spacingValue};
`;

export const CaptionSecondary = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const CaptionDisabled = styled(Caption)`
  color: ${colors.textDisabled};
`;

export const DateTimeUnderlineText = styled(Caption)`
  color: ${colors.textDisabled};
  text-decoration: underline;
  text-decoration-style: dashed;
`;

export const CardTitle = styled(Body2)`
  color: ${colors.textSecondary};
  margin: 0;
`;

export const BodyDisabled = styled(Body2)`
  color: ${colors.textDisabled};
  margin: 0;
`;

export const UnspacedBody2Bold = styled(Body2)`
  font-weight: ${fontWeights.bold};
  margin: 0;
`;

export const ContentDivider = styled(Divider)`
  margin: ${spacing.base} 0;
`;

export const RowDivider = styled.div`
  color: ${colors.purple50};
  padding-left: ${spacing.quarter};
`;

export const SkeletonRow = styled.div`
  display: flex;
`;

export const ColumnTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;
